import { JSResourceForUserVisible } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import { fg } from '@atlassian/jira-feature-gating';

export const softwareCodeEntrypoint = createEntryPoint({
	root: JSResourceForUserVisible(() =>
		import(/* webpackChunkName: "async-software-code-entrypoint" */ './src/ui').then(
			({ default: CodeSpa, CodeSpaV2 }) => {
				if (fg('jira-code-page-to-ugs-v2')) {
					return CodeSpaV2;
				}
				return CodeSpa;
			},
		),
	),
	getPreloadProps: () => ({}),
});
